<template>
  <div class="page--epk">
    <h1 class="background-jumbo-text left">chelliah</h1>
    <div class="nav left short">
      <internal-link
        to="/"
        text="Home"
        theme="mid"
        :onHover="hoverHome"
        :clearHover="clearHover"
      />
    </div>

    <div class="image-container right">
        <div class="image-items">
            <img :src="promoPhotoMain" width="auto" height="400"/>
            <img :src="promoPhoto" width="auto" height="400"/>
            <img :src="promoPhoto2" width="auto" height="400"/>
            <!-- <img :src="promoPhoto3" width="auto" height="400"/> -->
        </div>
    </div>
    <div class="text-container left">
      <!-- <h3 class="right short">My work</h3> -->
      <p >
        <strong>chelliah</strong> is the moniker for Chicago based electronic musician Erin Thomas. She creates techno, electronica, and ambient music that is intricate, textured, and melodic. Influenced by artists like Daphni, Perfume, and Floating Points, and drawing from her background in software engineering, she approaches modular synthesis as a space where technology and artistic expression meet.
      </p>  
      <p>
        Her debut album, <strong>an oceanic feeling</strong> (released in October 2025), presents eight tracks of bright and glitchy techno, fluttering between musical styles and weaving layers of modular sequences into a rich electronic tapestry. 
      </p>
      <iframe style="border: 0; width: 350px; height: 470px;margin: 0 calc(50% - 175px);" src="https://bandcamp.com/EmbeddedPlayer/album=2167598315/size=large/bgcol=ffffff/linkcol=0687f5/tracklist=false/transparent=true/" seamless><a href="https://chelliah.bandcamp.com/album/an-oceanic-feeling-2">an oceanic feeling by chelliah</a></iframe>
      <p style="text-align: center;">
        Listen to <external-link theme="dark" to="https://tr.ee/RzYPUGK-CP" text="an oceanic feeling"/>
      </p>
      <div class="social-icons-container">
        <a href="https://chelliah.bandcamp.com" target="_blank" aria-label="bandcamp">
            <img :src="bandcampLogo" />
        </a>
        <a href="https://instagram.com/chelliahhh" target="_blank" aria-label="instagram">
            <img :src="instagramLogo" />
        </a>
        <a href="https://music.apple.com/us/artist/chelliah/1616195634" target="_blank" aria-label="Apple Music">
            <img :src="appleLogo" />
        </a>
        <a href="https://soundcloud.com/chelliah" target="_blank" aria-label="SoundCloud">
            <img :src="soundcloudLogo" />
        </a>
      </div>
      <p>
        <strong>chelliah</strong> has performed live modular sets across Chicago at venues such as Sleeping Village, California Clipper, Uptown Lounge, and two editions of So Ambient at Podlasie Club. She has also collaborated in live performance art pieces combining dance, drag, and visual art.
      </p>

      <p>
        Contact: <external-link theme="dark" to="mailto:chelliahsmusic@gmail.com" text="chelliahsmusic@gmail.com" />
      </p>
    </div>
  </div>
</template>

<script>
import ExternalLink from "../components/ExternalLink";
import InternalLink from "../components/InternalLink";
import promoPhotoMain from "../assets/epk-photo-main.jpeg"
import promoPhoto from "../assets/epk-photo-1.jpeg"
import promoPhoto2 from "../assets/epk-photo-2.jpg"
// import promoPhoto3 from "../assets/epk-photo-3.jpeg"
import appleLogo from "../assets/logos/apple-music.svg"
import bandcampLogo from "../assets/logos/bandcamp.png"
import soundcloudLogo from "../assets/logos/soundcloud.png"
import instagramLogo from "../assets/logos/instagram.png"


export default {
  name: "MyWork",
  props: ["setSceneHoverTarget"],
  data() {
    return {
        promoPhotoMain:promoPhotoMain,
        promoPhoto: promoPhoto,
        promoPhoto2:promoPhoto2,
        // promoPhoto3:promoPhoto3,
        appleLogo:appleLogo,
        bandcampLogo:bandcampLogo,
        soundcloudLogo:soundcloudLogo,

        instagramLogo:instagramLogo
    }
  },
  components: {
    ExternalLink,
    InternalLink
  },
  beforeDestroy() {
    this.clearHover();
  },
  methods: {
    hoverAbout() {
      this.setSceneHoverTarget("u_hover_my_work", 1, 0);
    },
    clearHover() {
      this.setSceneHoverTarget("u_hover_my_work", 0, 0);
    },
    hoverHome() {
      this.setSceneHoverTarget("u_hover_my_work", 0, 1);
    }
  }
};
</script>

<style lang="scss" scoped>
.nav {
  position: fixed;
  right: 24px;
  top: 24px;

  :first-child {
    margin-right: 16px;
  }
  z-index: 120;
}

.page--epk {
  // background-color: $green-mint;
  display: block;
  overflow: visible;
  /* max-height: 1000px; */
  max-width: 1000px;
  position: relative;
  margin: auto;

  align-items: center; 

    padding: 20px;
    display: flex;
    position: relative;
    flex-direction: column;

    box-sizing: border-box;
}

.background-jumbo-text {
  @include agrandir-wide;
  font-style: italic;
  font-size: 90px;
  color: $green-light;;

  text-transform: uppercase;
  line-height: 90px;

  position: absolute;
  bottom: 60px;
  right: 60px;
  text-align: right;

  //   left: 24px;
  margin: 0;
  width: 400px;
  z-index: 2;
}

.image-container {
    display: flex;
    max-width: 100%;
    min-height: 400px;
    overflow-x: visible;
    overflow-y: hidden;

    .image-items {
        display: flex;
        width: auto;
        overflow-x: visible;
        white-space: nowrap;
    }

    img {
        margin: 1rem;

    }

}

hr {
    color: #426149;
    border-bottom: 1px solid #426149;
}

.social-icons-container {
    display: flex;
    padding: 1rem 1rem;
    margin: 0 1rem;
    justify-content: center;
    align-items: center;
    background: rgba(0,0,0,0.4);
    border-radius: 1rem;

    img {
        height: 48px;
    }
    a {
        padding: 0 1rem;
    }

    a:hover img {
        transform: scale(1.1);
    }

    // a:nth-of-type(1) {
    //     padding-right: .25rem;
    // }

    a:nth-of-type(4) img {
        height: 60px

    }
}

.text-container {
  width: 100%;
  z-index: 100;
  position: absolute;
  color: #426149;
  // height: 100%;
  //   overflow: scroll;
  //   padding: 100px 20px 0px 100px;
  // //   padding-top: 150px;
  //   width: calc(100% - 200px);
  //   height: 100vh;
  box-sizing: border-box;
  max-width: 560px;

  left: 32px;
  top: 50%;
  transform: translateY(-50%);
  padding: 1rem;

  * {
    max-width: 560px;
  }

  h3 {
    @include agrandir-grand;
    font-style: italic;
    font-size: 84px;
    font-weight: 300;
  }

  p {
    font-size: 20px;
    width: 100%;
  }
}

.nav {
  transition-delay: 0.1s;
}
.text-container {
  .right {
    transition-delay: 0.3s;
  }
  .left {
    transition-delay: 0.2s;
  }
}
.left,
.right {
  transition: transform 0.5s ease-out, opacity 0.5s ease-out;
}

.page--epk.toggle-slide-enter-active {
  //   transition-delay: 0.5s;
  .background-jumbo-text,
  .left,
  .right {
    transform: translate(0, 0);
    opacity: 1;
  }
}

.page--epk.toggle-slide-enter-active,
.toggle-slide-leave-active {
  //   transition: transform .7s, opacity 0.7s;
}

.page--epk.toggle-slide-enter {
  .background-jumbo-text,
  .text-container,
  .left,
  .right {
    opacity: 0;
  }
  .left {
    transform: translate(60px, 0);

    &.short {
      transform: translate(30px, 0);
    }
  }
  .right {
    transform: translate(-60px, 0);
    &.short {
      transform: translate(-30px, 0);
    }
  }
}

// .toggle-slide-enter-active {
//   opacity: 1;
// }

.page--epk.toggle-slide-leave-to /* .toggle-slide-leave-active below version 2.1.8 */ {
  .background-jumbo-text,
  .text-container,
  .left,
  .right {
    opacity: 0;
  }
  .left {
    transform: translate(-60px, 0);
    &.short {
      transform: translate(-30px, 0);
    }
  }
  .right {
    transform: translate(60px, 0);
    &.short {
      transform: translate(30px, 0);
    }
  }
}

// @supports ( -webkit-text-stroke-width: 4px) {
//   .background-jumbo-text {
//       color: transparent;
//       opacity: 1;
//     -webkit-text-stroke-width: 4px;
//     -webkit-text-stroke-color: #d4ffde;
//   }
// }

// @media only screen and (max-width: 1000px) {
  .page--epk {
  }

  .background-jumbo-text {
    bottom: unset;
    // top: 300px;
    // right: 30px;
    left: unset;
    font-size: 64px;
    // width: 300px;
    position: relative;
    right: unset;
    margin-top: 120px;;
  }

  .text-container {
    position: relative;
    transform: none;
    top: unset;
    left: unset;
    margin-top: 32px;
    background-color: rgba(255, 255, 255, 0.3);
  }

  .nav {
    position: absolute;
    display: flex;

    flex-direction: column;
    align-items: flex-end;

    :first-child {
      margin-right: 0;
    }
  }

  img {
    width: auto !important;
  }

  //    #me-img
// }
</style>
